// src/App.js
import React from 'react';
import { BrowserRouter as Router } from 'react-router-dom';
import TopNav from './components/Global/TopNav';
import AppRoutes from './routes/routes';
import Footer from './components/Global/Footer';
import './App.css';

function App() {
  return (
    <Router>
        <TopNav />
        <AppRoutes />
        <Footer />
    </Router>
  );
}

export default App;
